import React, { useState } from "react";
import styled from "styled-components";
import {
  PrimaryButton,
  SecondaryButton,
  ButtonSizeOptions,
  InputText,
  ButtonText
} from "@loanbossinc/component-library";

const Root = styled.div`
  font-family: Work Sans;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
`;

const Body = styled.div`
  display: flex;
  flex-direction: column;
  font-family: Work Sans;
  flex: 1;
  padding: 6px 0 30px 0;
`;

const Footer = styled.div`
  display: flex;
  justify-content: flex-end;
  font-family: Work Sans;
`;

export const DealSelector = props => {
  const { onCancel, onSelect } = props;

  const [dealId, setDealId] = useState("");

  const selectDeal = () => {

  };

  const isValid = () => Boolean(dealId);

  return (
    <Root>
      <Body>
        <ButtonText
          label="Jump to deal screener"
          iconName="arrow_forward"
          style={{ fontSize: 14, fontWeight: 500, justifyContent: "flex-start", padding: 0 }}
          onClick={() => {}}
        />
        <InputText
          variant="standard"
          placeholder="Deal ID here"
          label="Deal ID"
          name="dealId"
          type="text"
          onChange={e => setDealId(e.target.value)}
          value={dealId}
          style={{ marginTop: 16 }}
        />
      </Body>
      <Footer>
        <SecondaryButton
          label="Cancel"
          size={ButtonSizeOptions.smFluid}
          style={{ marginRight: 16, width: 132 }}
          onClick={onCancel}
        />
        <PrimaryButton
          label="Select"
          disabled={!isValid()}
          size={ButtonSizeOptions.smFluid}
          onClick={selectDeal}
          style={{ width: 132 }}
        />
      </Footer>
    </Root>
  );
};

export default DealSelector;
